'use client';

// base
import React, { useEffect, useMemo, useState } from 'react';
import { usePathname, useRouter } from 'next/navigation';

// style
import { StyledSideMenu } from './style';

// modules
import { type MenuItemProps } from 'modules';

// services
import { STORAGE_LOCAL_MENU_COLLAPSED, storageService } from 'services';

// libraries
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';

const menuList: MenuItemProps[] = [
  {
    menuId: 'dashboard',
    upMenuId: undefined,
    menuNm: 'Master Dashboard',
    menuIcon: '/assets/icons/menu/icon-menu-dashboard.svg',
    pgmUrl: '/dashboard',
    readYn: undefined,
    createYn: undefined,
    updateYn: undefined,
    deleteYn: undefined,
    excelDownYn: undefined,
    excelUpYn: undefined,
    order: 1
  },
  {
    menuId: 'admin-management',
    upMenuId: undefined,
    menuNm: 'Master Admin Management',
    menuIcon: '/assets/icons/menu/icon-menu-company.svg',
    pgmUrl: '/admin',
    readYn: 'Y',
    createYn: 'Y',
    updateYn: 'Y',
    deleteYn: 'Y',
    excelDownYn: 'N',
    excelUpYn: 'N',
    searchYn: 'Y',
    order: 3,
    subMenus: []
  }
  // {
  //   menuId: 'pjt-management',
  //   upMenuId: undefined,
  //   menuNm: 'PJT Management',
  //   menuIcon: '/assets/icons/menu/icon-menu-pjt.svg',
  //   pgmUrl: '/pjt',
  //   readYn: 'Y',
  //   createYn: 'Y',
  //   updateYn: 'Y',
  //   deleteYn: 'Y',
  //   excelDownYn: 'N',
  //   excelUpYn: 'N',
  //   searchYn: 'Y',
  //   order: 2,
  //   subMenus: []
  // }
];

export const SideMenu: React.FC = () => {
  const router = useRouter();
  const pathname = usePathname();

  const handleRouter = (menu: MenuItemProps) => {
    router.push(menu.pgmUrl as string);
  };

  return (
    <StyledSideMenu style={{ marginTop: 52 }}>
      {menuList &&
        menuList.map((item) => (
          <React.Fragment key={item.menuId}>
            <ListItemButton selected={item.pgmUrl === pathname} onClick={() => handleRouter(item)}>
              <ListItemIcon>
                <div className="item-icon" style={{ backgroundImage: `url(${item.menuIcon})` }} />
              </ListItemIcon>
              <ListItemText primary={item.menuNm} />
            </ListItemButton>
          </React.Fragment>
        ))}

      <div className="info">
        {/* <p>
          {import.meta.env.VITE_APP_VERSION ? `Version : ${import.meta.env.VITE_APP_VERSION}` : ''}
        </p>
        <p>
          {import.meta.env.VITE_APP_UPDATE_TIME
            ? `Last Updated : ${formattedDateEnShort(import.meta.env.VITE_APP_UPDATE_TIME)}`
            : ''}
        </p> */}
      </div>
    </StyledSideMenu>
  );
};
